import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import {
  dateReportFormatter,
  dateTimeReportFormatter,
  durationReportFormatter,
} from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import SubGroup from "../SubGroup";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

function UserList() {
  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/User/UserProfile_GetList`,
  });

  const [status, setStatus] = useState(0);
  const onStatusChange = useCallback(
    (event) => setStatus(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Status">
            <FormControl component="fieldset">
              <RadioGroup label value={status} onChange={onStatusChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Enabled"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Disabled"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Users List Report"
        getUrl={() => "/Reports/Report_User_List_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Profile: profile,
          Status: status,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          Login Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="profileName">
          Profile Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastLogin"
          dataFormat={dateTimeReportFormatter}
        >
          Last Login
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="status">
          Status
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default UserList;
